var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(
      _vm.$store.state.user.isLoggedIn &&
        (!_vm.isMobile || _vm.$router.currentRoute.name !== 'MeasureGraph')
    )?_c('app-header',{attrs:{"admin":_vm.admin}}):_vm._e(),_c('router-view',{attrs:{"is-mobile":_vm.isMobile,"window-height":_vm.windowHeight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }